var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{model:{value:(_vm.loadingOverlayOpen),callback:function ($$v) {_vm.loadingOverlayOpen=$$v},expression:"loadingOverlayOpen"}},[_c('v-progress-circular',{attrs:{"size":100,"width":10,"color":"primary","indeterminate":""}}),_c('p',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.loadingOverlayText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }